import { Component, OnInit } from '@angular/core';
import { CategoriaService } from '../../../services/categoria/categoria.service';
import { CarritoService } from '../../../services/carrito/carrito.service';
import { ElementoCarro } from '../../../../model/interface/ElementoCarro';
import { ProductoService } from '../../../services/producto/producto.service';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { IProducto } from '../../../../model/interface/IProducto';
import * as _ from 'lodash';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import {AuthService} from '../../../services/auth/auth.service';


@Component({
  selector: 'app-navlinks',
  templateUrl: './navlinks.component.html',
  styleUrls: ['./navlinks.component.css'],
  animations: [

    trigger('visibility-menu', [
      state('in', style({
        height: '*',
      })),
      state('out', style({
        height: '0', overflow : 'hidden', display: 'none'
      })),
      transition('in => out', animate('200ms ease-in')),
      transition('out => in', animate('200ms ease-out'))
    ]),
    trigger('visibility-search', [
      state('in', style({
        height: '*',
      })),
      state('out', style({
        height: '0', overflow : 'hidden'
      })),
      transition('in => out', animate('200ms ease-in')),
      transition('out => in', animate('200ms ease-out'))
    ]),
    trigger('manu-transition', [
      transition(':enter', [
        style({ opacity: '0' }),
        animate(0)
      ]),
      transition(':leave', [
        animate(0, style({ opacity: '0' }))
      ]),
      state('*', style({ opacity: '1' })),
    ])
  ]
})
export class NavlinksComponent implements OnInit {

  arbolCategorias: any[] = [];
  carroProductos: ElementoCarro[] = [];
  statusMenu = 'out';
  statusSearch = 'out';
  statusMap = 'out';

  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();
  cargandoBusqueda = true;
  productosBusqueda: IProducto[] = [];
  cFantasiaParams: any;
  activeCategoria: number = null;

  isLoged = false;

  loaders = {
    categorias: false
  };

  visibleMenu = true;

  constructor(
    private _categoriaService: CategoriaService,
    private _carritoService: CarritoService,
    private route: ActivatedRoute,
    private router: Router,
    private _productoService: ProductoService,
    private _authService: AuthService,
  ) {

    this.router.events.subscribe((val: any) => {
      if (val.url === '/cotizaciones') {
        this.visibleMenu = false;
      } else {
        this.visibleMenu = true;
      }
    });

    this.cFantasiaParams = {'per_page': 6, 'visibility': ['MENU']};

    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.textoBuscar = model.toString();

        if (this.textoBuscar === '') {
          this.productosBusqueda = [];
        } else {
          this.buscarProducto();
        }
      });

    this.isLoged = this._authService.isLoged();
  }

  ngOnInit() {
    this.init();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this._productoService.setProductoCategoriaActive(null);
        let padreId = null;
        const categoriaHijaId = event.url.split('/')[2];
        this.arbolCategorias.forEach(item => {
          item.categoriasHijas.forEach(item2 => {
            if (item2.id === parseInt(categoriaHijaId)) {
              padreId = item.id;
            }
          });
        });
        // this.activeCategoria = padreId;
      }
    });
    // subscribirse cuando las categorias terminan de cargar
    this._productoService.categoriaWasLoaded.subscribe((newBool: boolean) => {
      this.isActive();
    });
  }

  init () {
    this._carritoService.carroProductos.subscribe(carro => {
      if (carro) {
        this.carroProductos = carro;
      }
    } );

    this._categoriaService.getArbolCompleto()
      .subscribe( data => {
        this.arbolCategorias = data;
        this.showSubMenu(-1);
        this.loaders.categorias = true;

        _.each(this.arbolCategorias, (padre) => {
          padre.selected = false;
          this._categoriaService.getHijasDeFantasia(padre.id, this.cFantasiaParams)
            .subscribe( resp => {
              padre.hijasFantasia = resp;
            });

          this._categoriaService.getArchivos(padre.id, {'per_page': 1, 'tipo': 'CATEGORIA_BANNER_MENU'})
            .subscribe( resp => {
              if (resp[0]) {
                padre.banner = resp[0];
              }
            });
        });
        this.isActive();
      });
  }

  goToCategory(idCategory: number) {
    this.statusMenu = 'out';
    this.router.navigate(['/categoria', idCategory, 0]);
  }

  showMenu() {
    this.statusMenu = this.statusMenu === 'out' ? 'in' : 'out';
    // this.muestraMenu = !this.muestraMenu;
  }

  showMap() {
    this.showSubMenu(-1);
    this.statusMap = this.statusMap === 'out' ? 'in' : 'out';
    // this.muestraMenu = !this.muestraMenu;
  }

  showSearch() {
    this.limpiarTexto();
    this.statusSearch = this.statusSearch === 'out' ? 'in' : 'out';
    document.getElementById('quick-search-movil').focus();
  }

  hidenMenu() {
    this.statusMenu = 'out';
  }

  hidenSearch() {
    this.statusSearch = 'out';
    this.limpiarTexto();
  }

  hidenAll() {
    this.statusSearch = 'out';
    this.statusMenu = 'out';
  }

  showSubMenu( index: number ) {

    if (index >= 0) {
      this.statusMap = 'out';
    }

    _.each(this.arbolCategorias, (categoria, i) => {
      if (index === i) {
        if (categoria.statusSubMenu === 'out') {
          categoria.statusSubMenu = 'in';
        } else {
          categoria.statusSubMenu = 'out';
        }
      } else {
        categoria.statusSubMenu = 'out';
      }
    });
  }

  isActive () {
    if (this.router.url.includes('/producto')){
      if (!this._productoService.getProductoCategoriaActive()) {
        if (this._productoService.getProductoCategorias()) {
          const cat = this._productoService.getProductoCategorias()[0];
          _.each(this.arbolCategorias, (catPadre: any) => {
            if (cat.categoria.categoriaId === catPadre.id) {
              // this.activeCategoria = catPadre.id;
            }
          });
        }
      }else {
        _.each(this.arbolCategorias, (catPadre: any) => {
          if (this._productoService.getProductoCategoriaActive() === catPadre.id) {
              // this.activeCategoria = catPadre.id;
          }
        });
      }
    }else {
      let padreId = null;
      const categoriaHijaId = this.router.url.split('/')[2];
      this.arbolCategorias.forEach(item => {
        item.categoriasHijas.forEach(item2 => {
          if (item2.id === parseInt(categoriaHijaId)) {
            padreId = item.id;
          }
        });
      });
      // this.activeCategoria = padreId;
    }
  }

  buscarProducto () {

    let texto =  this.textoBuscar.replace(new RegExp('span', 'ig'), '');
    texto = _.trim(texto);

    if (texto) {

      const objetoBucar: any[] = [{'name': texto}];
      const parametros = {search: JSON.stringify(objetoBucar)};

      this._productoService.getPublicados(parametros)
        .subscribe( data => {
          this.productosBusqueda = data;
          this.cargandoBusqueda = false;
        });
    } else {
      this.productosBusqueda = [];
      this.cargandoBusqueda = false;
    }
  }

  limpiarTexto () {
    this.productosBusqueda = [];
    this.textoBuscar = '';
  }


  onTextoBuscarChange(texto: string) {
    this.cargandoBusqueda = true;
    this.textoBuscarChanged.next(texto);
  }

  actveMenu(itemMenu) {
    const newState = !itemMenu.selected;
    this.arbolCategorias.map((item) => {
      item.selected = false;
    });
    itemMenu.selected = newState;
  }

  goToDesktopCategorie(parent, idHijo, idNieto ) {
    parent.selected = false;
    this.router.navigate(['/categoria', idHijo, idNieto]);
  }

  ocultarMenu(event) {
    this.arbolCategorias.map((item) => {
      item.selected = false;
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/structure/navlinks/navlinks.component.ts